import { Dropdown, TextField } from '@symphony-ui/uitoolkit-components';
import PopupContext from 'contexts/PopupContext';
import * as React from 'react';
import './PeriodEditor.css';
const PeriodEditor = ({ defaultPeriod, label = "", onChange, regex = /^(1|2|3|6|9|12)?$/, style, value }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [period, setPeriod] = React.useState(value?.period ?? defaultPeriod ?? 'M');
    const [periodMultiplier, setPeriodMultiplier] = React.useState(value?.periodMultiplier.toString() ?? '');
    const options = React.useMemo(() => [{ label: 'D', value: 'D' }, { label: 'W', value: 'W' }, { label: 'M', value: 'M' }, { label: 'Y', value: 'Y' }], []);
    const set = React.useCallback((newValue) => {
        const newPeriod = newValue.periodMultiplier === '' ? undefined :
            {
                period: newValue.period,
                periodMultiplier: Number.parseFloat(newValue.periodMultiplier)
            };
        onChange({ target: { value: newPeriod } });
    }, [onChange]);
    const onChangePeriodMultiplier = React.useCallback((event) => {
        const newValue = event.target.value;
        if (regex.exec(event.target.value) !== null) {
            setPeriodMultiplier(newValue);
            set({ period, periodMultiplier: newValue });
        }
    }, [set, period, regex]);
    const onChangePeriod = React.useCallback((event) => {
        const newValue = event.target.value.value;
        setPeriod(newValue);
        set({ period: newValue, periodMultiplier });
    }, [set, periodMultiplier]);
    return (React.createElement("div", { style: style },
        React.createElement(TextField, { className: "input-with-addon period-input", label: label, onChange: onChangePeriodMultiplier, rightDecorators: (React.createElement(Dropdown, { className: "select-addon", isTypeAheadEnabled: false, label: "", onMenuClose: () => setBlockClose(false), onMenuOpen: () => setBlockClose(true), onChange: onChangePeriod, options: options, value: options.find((o) => 'value' in o && o.value === period) })), value: periodMultiplier })));
};
export default PeriodEditor;
